module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-img-02-44e49e55b03ddadbe99639fbbd9e493a.png";